import expandIcon from "../../assests/page/chevron-down.svg";
import closeDropdown from "../../assests/page/chevron-up.svg";
import closeIcon from "../../assests/overlay/close-icon.svg";
import React, { useState } from "react";
import {
  ChainConfig,
  chainDetails,
  supportedChainsIds,
  useWalletInApp,
} from "../../utils/config";
import closeExpandIcon from "../../assests/overlay/close-expand.svg";
import searchIcon from "../../assests/sideBar/search-icon.svg";
import checkCircle from "../../assests/overlay/check-circle.svg";
import infoIcon from "../../assests/overlay/info-blue.svg";
import { wagmiAdapter } from "../..";
import ethereumIcon from "../../assests/overlay/ethereum-icon.svg";
import nearIcon from "../../assests/overlay/near-icon.svg";
import solanaIcon from "../../assests/overlay/solana-logo.svg";
import ProfilePopup from "./profile";
import { useNavigate } from "react-router-dom";
import verifiedLogo from "../../assests/page/icon128.png";
import walletConnectIcon from "../../assests/page/wallet-connect-icon.webp";
import { useAppKit } from "@reown/appkit/react";
import useNetworkStore from "../../store/networkStore";
import InAppWallet from "./mobileWallet";
import { errorToast, verifiedWalletDownloadLink } from "../../utils/constants";
import hexTrustIconBlue from "../../assests/page/hextrusticonblue.jpg";
import { Provider, VerifiedWallet } from "@verified-network/verified-sdk";
import VerifyKYC from "./verifyKYC";
import LoadingPopup from "./loading";

import { useWalletSelector } from "@near-wallet-selector/react-hook";
import { switchNetwork } from "../../utils/helpers/utils";
import { useConnector } from "@solana-commerce/connector";
import { useTranslation } from "react-i18next";

export const UnsupportedNetwork = (props) => {
  const { t } = useTranslation();
  const [selectedNetwork, setSelectedNetwork] = useState({ search: "" });
  const [showNetworks, setShowNetworks] = useState(false);

  const handleSwitchNetworkButtonDisplay = () => {
    const button = document.getElementById("switch-network-button");
    if (button && Object.keys(selectedNetwork).length > 0) {
      button.className = "startup-button-active";
    } else if (button) {
      button.className = "startup-button";
    }
  };

  return (
    <div style={{ marginTop: "50px" }} className="unsupported-network-popup">
      <div className="unsupported-network-popup-cont">
        <div className="unsupported-network-popup-first">
          <p className="unsupported-network-popup-first-title">
            Unsupported Network
          </p>
          <p className="unsupported-network-popup-first-label">
            The network you are connected to is currently not supported by
            Verified Network. You’er currently connected to{" "}
            <b>
              {ChainConfig[Number(props.chainId)]?.chainName
                ? ChainConfig[Number(props.chainId)]?.chainName
                : ""}{" "}
            </b>
            network.
          </p>
          <div className="unsupported-network-popup-first-img">
            <img
              style={{ cursor: "pointer" }}
              onClick={() => {
                props.setPopupContent(
                  <Login
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setCustomLoading={props.setCustomLoading}
                    setVerifiedWalletDetails={props.setVerifiedWalletDetails}
                    verifiedWalletDetails={props.verifiedWalletDetails}
                    mobileScreen={props.mobileScreen}
                    generalDataProps={props.generalDataProps}
                  />,
                );
                props.setPopupContentPosition("center");
                props.setShowPopup(true);
              }}
              src={closeIcon}
              alt="Close Icon"
            />
          </div>
        </div>
        <div className="unsupported-network-popup-second">
          <p className="unsupported-network-popup-second-title">
            Supported network are:{" "}
            <span className="unsupported-network-popup-second-label">
              {supportedChainsIds
                .map((chn) => ChainConfig[chn]?.chainName)
                .join(" , ")}
            </span>
          </p>

          <div className="unsupported-network-popup-dropdown-cont">
            <div className="unsupported-network-popup-dropdown">
              {!showNetworks && (
                <div
                  onClick={() => {
                    setSelectedNetwork({ ...selectedNetwork, clicked: true });
                    setShowNetworks(!showNetworks);
                  }}
                  className="unsupported-network-popup-dropdown-text-cont"
                >
                  {!selectedNetwork?.chainName && (
                    <p className="unsupported-network-popup-dropdown-text">
                      Select Network
                    </p>
                  )}
                  {selectedNetwork?.chainName && (
                    <p className="unsupported-network-popup-dropdown-text">
                      {selectedNetwork?.chainName}
                    </p>
                  )}
                </div>
              )}
              {showNetworks && (
                <div
                  style={{
                    width: "100%",
                  }}
                  className="a-f-content-footer-input-group"
                >
                  {showNetworks && (
                    <input
                      onInput={(e) => {
                        setSelectedNetwork({
                          ...selectedNetwork,
                          search: e.target.value,
                        });
                      }}
                      type="text"
                      className="offer-security-expand-input"
                      placeholder={t("placeholder.search")}
                    />
                  )}
                </div>
              )}
              <img
                onClick={() => {
                  setSelectedNetwork({ ...selectedNetwork, clicked: true });
                  setShowNetworks(!showNetworks);
                }}
                src={expandIcon}
                alt="Expand Icon"
              />
            </div>
            {showNetworks && (
              <div className="offer-security-popup-body-expand-container">
                {supportedChainsIds.map((chn, idx) => (
                  <>
                    {selectedNetwork.search === "" && (
                      <div
                        style={{ cursor: "pointer" }}
                        id={idx}
                        onClickCapture={() =>
                          setSelectedNetwork({
                            ...ChainConfig[chn],
                            clicked: false,
                            search: "",
                            idx: idx,
                          })
                        }
                        onClick={() => {
                          handleSwitchNetworkButtonDisplay();
                          setShowNetworks(false);
                        }}
                        className="offer-security-popup-body-first-expand-cont"
                      >
                        <p className="offer-security-popup-body-first-expand-text">
                          {ChainConfig[chn]?.chainName}
                        </p>

                        <div
                          style={{
                            height: "1px",
                            width: "100%",
                            background: "#EEEEF0",
                          }}
                        ></div>
                      </div>
                    )}
                    {selectedNetwork.search?.length > 0 &&
                      ChainConfig[chn]?.chainName
                        ?.toLowerCase()
                        .includes(selectedNetwork.search.toLowerCase()) && (
                        <div
                          style={{ cursor: "pointer" }}
                          id={idx}
                          onClickCapture={() =>
                            setSelectedNetwork({
                              ...ChainConfig[chn],
                              clicked: false,
                              search: "",
                              idx: idx,
                            })
                          }
                          onClick={() => {
                            handleSwitchNetworkButtonDisplay();
                            setShowNetworks(false);
                          }}
                          className="offer-security-popup-body-first-expand-cont"
                        >
                          <p className="offer-security-popup-body-first-expand-text">
                            {ChainConfig[chn]?.chainName}
                          </p>

                          <div
                            style={{
                              height: "1px",
                              width: "100%",
                              background: "#EEEEF0",
                            }}
                          ></div>
                        </div>
                      )}
                  </>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <button
        id="switch-network-button"
        style={{ marginBottom: "0" }}
        onClick={async (e) => {
          if (
            e.target.className.includes("startup-button") &&
            e.target.className !== "startup-button"
          ) {
            e.target.className = "startup-button-click";
            if (window?.verifiedwallet?.request && selectedNetwork.idx) {
              props.setCustomLoading(true);
              await window.verifiedwallet
                .request({
                  method: "connectWallet",
                  params: { chainId: supportedChainsIds[selectedNetwork.idx] },
                })
                .then((res) => {
                  props.setCustomLoading(false);
                  if (res?.length > 0) {
                    props.setVerifiedWalletDetails(res[0]);
                    props.setPopupContent(null);
                    props.setPopupContentPosition("center");
                    props.setShowPopup(false);
                  }
                });
            } else if (selectedNetwork.idx && !window?.verifiedwallet) {
              props.setPopupContent(
                <DownloadVerifiedWallet
                  setShowPopup={props.setShowPopup}
                  setPopupContent={props.setPopupContent}
                  setPopupContentPosition={props.setPopupContentPosition}
                  mobileScreen={props.mobileScreen}
                  verifiedWalletDetails={props.verifiedWalletDetails}
                  generalDataProps={props.generalDataProps}
                />,
              );
              props.setPopupContentPosition("center");
              props.setShowPopup(true);
            }
          } else {
            const buttonElement = document.getElementsByClassName(
              "startup-button-active",
            );
            if (buttonElement.length > 0) {
              buttonElement[0].className = "startup-button-click";
              if (window?.verifiedwallet?.request && selectedNetwork.idx) {
                props.setCustomLoading(true);
                await window.verifiedwallet
                  .request({
                    method: "connectWallet",
                    params: {
                      chainId: supportedChainsIds[selectedNetwork.idx],
                    },
                  })
                  .then((res) => {
                    props.setCustomLoading(false);
                    if (res?.length > 0) {
                      props.setVerifiedWalletDetails(res[0]);
                      props.setPopupContent(null);
                      props.setPopupContentPosition("center");
                      props.setShowPopup(false);
                    }
                  });
              } else if (selectedNetwork.idx && !window?.verifiedwallet) {
                props.setPopupContent(
                  <DownloadVerifiedWallet
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    mobileScreen={props.mobileScreen}
                    verifiedWalletDetails={props.verifiedWalletDetails}
                    generalDataProps={props.generalDataProps}
                  />,
                );
                props.setPopupContentPosition("center");
                props.setShowPopup(true);
              }
            }
          }
        }}
        className="startup-button"
      >
        <p className="add-funds-popup-a-f-button-text">Switch Network</p>
      </button>
    </div>
  );
};

export const SwitchNetwork = (props) => {
  const { t } = useTranslation();
  const { chainId } = useNetworkStore();

  const [selectedNetworkId, setSelectedNetworkId] = useState(chainId);
  const {
    verifiedWalletDetails,
    custodyWalletDetails,
    setVerifiedWalletDetails,
    setCustodyWalletDetails,
  } = props.generalDataProps;

  const navigate = useNavigate();

  return (
    <div className="switch-network-popup">
      <div className="switch-network-popup-first">
        <div className="switch-network-popup-first-section">
          <div className="switch-network-popup-first-section-cont">
            <p className="switch-network-popup-first-section-title">
              Choose Network
            </p>

            <img
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("?profile");
                props.setPopupContentPosition("flex-end");
                props.setPopupContent(
                  <ProfilePopup
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    setPageAction={props.setPageAction}
                    verifiedWalletDetails={props.verifiedWalletDetails}
                    custodyWalletDetails={props.custodyWalletDetails}
                    setVerifiedWalletDetails={props.setVerifiedWalletDetails}
                    generalDataProps={props.generalDataProps}
                  />,
                );
                props.setFavouriteClicked(true);
                props.setShowPopup(true);
              }}
              src={closeIcon}
              alt=""
            />
          </div>
          <div
            style={{
              width: "100%",
              border: "1px solid var(--Neutral-200, #D8D9DF)",
              borderRadius: "8px",
            }}
            className="a-f-content-footer-input-group"
          >
            <input
              type="text"
              className="offer-security-expand-input"
              placeholder={t("placeholder.networkSearch")}
            />
            <img alt="Search Icon" src={searchIcon} />
          </div>
        </div>

        <div className="switch-network-popup-first-section-body">
          {wagmiAdapter?.wagmiChains?.map((chn) => (
            <>
              {selectedNetworkId === chn.id && (
                <div
                  onClick={() => {
                    setSelectedNetworkId(chn.id);
                    props.setShowPopup(false);
                    props.setPopupContent(null);
                    props.setPopupContentPosition("center");
                  }}
                  className="switch-network-popup-first-section-content-cont-active"
                >
                  <div className="switch-network-popup-first-section-content">
                    {chainDetails[Number(chn.id)]?.icon && (
                      <img
                        style={{
                          height: "24px",
                          width: "24px",
                          overflow: "hidden",
                          borderRadius: "40px",
                        }}
                        src={chainDetails[chn.id]?.icon}
                        alt="Chain Icon"
                      />
                    )}

                    <p className="switch-network-popup-first-section-cont-text">
                      {chn.name}
                    </p>
                  </div>

                  <img
                    className="switch-network-popup-first-section-cont-img"
                    src={checkCircle}
                    alt=""
                  />
                </div>
              )}
              {selectedNetworkId !== chn.id && (
                <div
                  onClick={async () => {
                    setSelectedNetworkId(chn.id);
                    props.setCustomLoading(true);
                    if (Object.keys(custodyWalletDetails)?.length > 0) {
                      let newDetails = { ...custodyWalletDetails };
                      newDetails.chainId = Number(chn.id);
                      setCustodyWalletDetails(custodyWalletDetails);

                      props.setCustomLoading(false);
                      props.setShowPopup(false);
                      props.setPopupContent(null);
                      props.setPopupContentPosition("center");
                      navigate("/");
                    } else if (Object.keys(verifiedWalletDetails)?.length > 0) {
                      let newDetails = { ...verifiedWalletDetails };
                      newDetails.chainId = Number(chn.id);
                      setVerifiedWalletDetails(newDetails);

                      props.setCustomLoading(false);
                      props.setShowPopup(false);
                      props.setPopupContent(null);
                      props.setPopupContentPosition("center");
                      navigate("/");
                    } else {
                      await switchNetwork(chn.id, window).then((res) => {
                        props.setCustomLoading(false);
                        if (res) {
                          props.setShowPopup(false);
                          props.setPopupContent(null);
                          props.setPopupContentPosition("center");
                          navigate("/");
                        }
                      });
                    }
                  }}
                  className="switch-network-popup-first-section-content-cont"
                >
                  <div className="switch-network-popup-first-section-content">
                    {chainDetails[Number(chn.id)]?.icon && (
                      <img
                        style={{
                          height: "24px",
                          width: "24px",
                          overflow: "hidden",
                          borderRadius: "40px",
                        }}
                        src={chainDetails[chn.id]?.icon}
                        alt="Chain Icon"
                      />
                    )}
                    <p className="switch-network-popup-first-section-cont-text">
                      {chn.name}
                    </p>
                  </div>
                </div>
              )}
            </>
          ))}
        </div>
      </div>

      <div className="switch-network-popup-line"></div>

      <div className="switch-network-popup-second">
        <p className="switch-network-popup-second-title">
          Your connect wallet may not supported some of the network available
          for this dApp
        </p>
        <div className="switch-network-popup-second-text-cont">
          <img src={infoIcon} alt="Info Icon" />
          <a
            className="switch-network-popup-second-text"
            href="https://ethereum.org/en/developers/docs/networks/"
            target="_blank"
            rel="noopener noreferrer"
          >
            What is a network
          </a>
        </div>
      </div>
    </div>
  );
};

export const Login = (props) => {
  const appKitModal = useAppKit();
  const [showOtherWallets, setShowOtherWallets] = useState(false);
  const [showSolanaWallets, setShowSolanaWallets] = useState(false);
  const { signIn } = useWalletSelector();
  const { wallets, select } = useConnector();

  const handleNearSignIn = () => {
    signIn();
  };

  return (
    <div style={{ marginTop: "50px" }} className="switch-network-popup">
      <div className="switch-network-popup-first">
        <div className="switch-network-popup-first-section">
          <div className="switch-network-popup-first-section-cont">
            <p className="switch-network-popup-first-section-title">
              Login Options
            </p>

            <img
              style={{ cursor: "pointer" }}
              onClick={() => {
                props.setPopupContentPosition("center");
                props.setPopupContent(null);
                props.setShowPopup(false);
              }}
              src={closeIcon}
              alt=""
            />
          </div>
        </div>

        {!showOtherWallets && (
          <div
            style={{ gap: "20px", marginTop: "10px", marginBottom: "10px" }}
            className="switch-network-popup-first-section-body"
          >
            <div
              onClick={async () => {
                try {
                  if (window?.verifiedwallet?.request) {
                    props.setCustomLoading(true);
                    await window.verifiedwallet
                      .request({
                        method: "connectWallet",
                        chainId:
                          chainDetails[0].verifiedWalletChainId ||
                          chainDetails[0].chainId,
                      })
                      .then((res) => {
                        props.setCustomLoading(false);
                        if (res?.length > 0) {
                          props.setVerifiedWalletDetails(res[0]);
                          localStorage.setItem(
                            "VW:myVault",
                            JSON.stringify(res[0]),
                          );
                          props.setPopupContent(null);
                          props.setPopupContentPosition("center");
                          props.setShowPopup(false);
                        }
                      });
                  } else if (props.mobileScreen || useWalletInApp) {
                    props.setPopupContent(
                      <InAppWallet
                        action="connect_wallet"
                        origin={window.location.origin}
                        title={"Verified Network"}
                        verifiedWalletDetails={props.verifiedWalletDetails}
                        mobileScreen={props.mobileScreen}
                      />,
                    );
                    props.setPopupContentPosition("center");
                    props.setShowPopup(true);
                  } else {
                    props.setPopupContent(
                      <DownloadVerifiedWallet
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        mobileScreen={props.mobileScreen}
                        verifiedWalletDetails={props.verifiedWalletDetails}
                        generalDataProps={props.generalDataProps}
                      />,
                    );
                    props.setPopupContentPosition("center");
                    props.setShowPopup(true);
                  }
                } catch (err) {
                  props.setCustomLoading(false);
                  if (err === "window closed.") {
                    // eslint-disable-next-line no-self-assign
                    window.location.href = window.location.href;
                  }
                }
              }}
              className="switch-network-popup-first-section-content-cont"
            >
              <div className="switch-network-popup-first-section-content">
                <img
                  style={{
                    height: "32px",
                    width: "32px",
                    overflow: "hidden",
                    borderRadius: "40px",
                  }}
                  src={verifiedLogo}
                  alt="Chain Icon"
                />

                <p className="switch-network-popup-first-section-cont-text">
                  Verified Wallet
                </p>
              </div>
            </div>

            <div
              onClick={async () => {
                setShowOtherWallets(true);
              }}
              className="switch-network-popup-first-section-content-cont"
            >
              <div className="switch-network-popup-first-section-content">
                <img
                  style={{
                    height: "32px",
                    width: "32px",
                    overflow: "hidden",
                    borderRadius: "40px",
                  }}
                  src={walletConnectIcon}
                  alt="Chain Icon"
                />
                <p className="switch-network-popup-first-section-cont-text">
                  Other Wallets
                </p>
              </div>
            </div>
          </div>
        )}
        {showOtherWallets && !showSolanaWallets && (
          <div
            style={{ gap: "20px", marginTop: "10px", marginBottom: "10px" }}
            className="switch-network-popup-first-section-body"
          >
            <div
              onClick={handleNearSignIn}
              className="switch-network-popup-first-section-content-cont"
            >
              <div className="switch-network-popup-first-section-content">
                <img
                  style={{
                    height: "32px",
                    width: "32px",
                    overflow: "hidden",
                    borderRadius: "40px",
                  }}
                  src={nearIcon}
                  alt="Chain Icon"
                />

                <p className="switch-network-popup-first-section-cont-text">
                  Near Wallets
                </p>
              </div>
            </div>

            <div
              onClick={async () => {
                setShowSolanaWallets(true);
              }}
              className="switch-network-popup-first-section-content-cont"
            >
              <div className="switch-network-popup-first-section-content">
                <img
                  style={{
                    height: "32px",
                    width: "32px",
                    overflow: "hidden",
                    borderRadius: "40px",
                  }}
                  src={solanaIcon}
                  alt="Chain Icon"
                />
                <p className="switch-network-popup-first-section-cont-text">
                  Solana Wallets
                </p>
              </div>
            </div>

            <div
              onClick={async () => {
                appKitModal.open();
                props.setShowPopup(false);

                props.setPopupContent(null);
                props.setPopupContentPosition("center");
                props.setVerifiedWalletDetails({});
              }}
              className="switch-network-popup-first-section-content-cont"
            >
              <div className="switch-network-popup-first-section-content">
                <img
                  style={{
                    height: "32px",
                    width: "32px",
                    overflow: "hidden",
                    borderRadius: "40px",
                  }}
                  src={walletConnectIcon}
                  alt="Chain Icon"
                />
                <p className="switch-network-popup-first-section-cont-text">
                  Other Wallets
                </p>
              </div>
            </div>
          </div>
        )}
        {showOtherWallets && showSolanaWallets && (
          <div
            style={{ gap: "20px", marginTop: "10px", marginBottom: "10px" }}
            className="switch-network-popup-first-section-body"
          >
            {wallets.map((wlt) => (
              <React.Fragment>
                {wlt?.icon && wlt?.name && wlt?.connectable && (
                  <div
                    className="switch-network-popup-first-section-content-cont"
                    onClick={async () => {
                      props.setCustomLoading(true);
                      try {
                        await select(wlt?.name).then(() => {
                          props.setCustomLoading(false);
                          props.setShowPopup(false);

                          props.setPopupContent(null);
                          props.setPopupContentPosition("center");
                          props.setVerifiedWalletDetails({});
                        });
                      } catch (err) {
                        props.setCustomLoading(false);
                      }
                    }}
                  >
                    <div className="switch-network-popup-first-section-content">
                      <img
                        style={{
                          height: "32px",
                          width: "32px",
                          overflow: "hidden",
                          borderRadius: "40px",
                        }}
                        src={wlt?.icon}
                        alt="Wallet Icon"
                      />

                      <p className="switch-network-popup-first-section-cont-text">
                        {wlt?.name}
                      </p>
                    </div>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>

      {!showOtherWallets && (
        <React.Fragment>
          <div className="switch-network-popup-line"></div>

          <div className="switch-network-popup-second">
            <div className="switch-network-popup-second-text-cont">
              <img src={infoIcon} alt="Info Icon" />
              <a
                className="switch-network-popup-second-text"
                href="https://chromewebstore.google.com/detail/verified-wallet/abkgckcpmnbipkfhkkchkdfkmccjdmkh"
                target="_blank"
                rel="noopener noreferrer"
              >
                What is Verified Wallet
              </a>
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export const DownloadVerifiedWallet = (props) => {
  return (
    <div style={{ marginTop: "50px" }} className="switch-network-popup">
      <div className="switch-network-popup-first">
        <div className="switch-network-popup-first-section">
          <div className="switch-network-popup-first-section-cont">
            <p className="switch-network-popup-first-section-title">
              Verified Wallet Not Installed
            </p>

            <img
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (props.setPopupContentPosition) {
                  props.setPopupContentPosition("center");
                }
                if (props.setPopupContent) {
                  props.setPopupContent(
                    <Login
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      setCustomLoading={props.setCustomLoading}
                      setVerifiedWalletDetails={props.setVerifiedWalletDetails}
                      verifiedWalletDetails={props.verifiedWalletDetails}
                      mobileScreen={props.mobileScreen}
                      generalDataProps={props.generalDataProps}
                    />,
                  );
                }

                if (props.setShowPopup) {
                  props.setShowPopup(true);
                }
              }}
              src={closeIcon}
              alt=""
            />
          </div>
        </div>
      </div>

      <div className="switch-network-popup-line"></div>

      <div className="switch-network-popup-second">
        <p className="switch-network-popup-second-title">
          Download Verified Wallet for easy login and gassless transactions with
          one tap.
        </p>
        <button
          style={{ marginBottom: "0" }}
          onClick={async (e) => {
            if (
              e.target.className.includes("startup-button") &&
              e.target.className !== "startup-button"
            ) {
              e.target.className = "startup-button-click";
            } else {
              const buttonElement = document.getElementsByClassName(
                "startup-button-active",
              );
              if (buttonElement.length > 0) {
                buttonElement[0].className = "startup-button-click";
              }
            }

            const newTab = window.open(verifiedWalletDownloadLink, "_blank");

            if (newTab) {
              newTab.focus();
            }
          }}
          className="startup-button-active"
        >
          <p className="add-funds-popup-a-f-button-text">Download</p>
        </button>
      </div>
    </div>
  );
};
